import React from 'react';

import {FilterInput} from 'src/components/input';

import {Group} from '@pb/kit-component-group';
import Label from '@pb/kit-component-label';

type Props = {
    message?: string,
    onChange: (accountName: string) => void,
};

export const NotificationTitleFilter = ({message, onChange}: Props) => (
    <Group direction="v" style={{width: 250}}>
        <Label>Notification Title</Label>
        <FilterInput
            id="notification-title-filter"
            value={message || ''}
            placeholder="Notification Title"
            onChange={onChange}
            onClear={() => onChange('')}
            timeOut={500}
        />
    </Group>
);
